
const posts = (state = [], action) => {
  const { payload, type } = action;

  let idsList, calculatedPayload;
  switch (type) {
    case 'INITIAL_DATA':
      idsList = [
        ...payload.home?.posts.map((x) => x._id),
        ...(payload.user?.posts ? payload.user?.posts.map((x) => x._id) : [])
      ];

      return [
        ...(payload.home?.posts || []),
        ...(payload.user?.posts || []),
        ...state.filter((x) => !idsList.includes(x._id))
      ];

    case 'SET_POSTS':
      idsList = payload.map((id) => id._id);

      return [...payload, ...state.filter((post) => !idsList.includes(post._id))];

    case 'UPDATE_POST':
      return state.map((post) => {
        if (post._id !== payload._id) return post;

        return {
          ...post,
          ...payload
        };
      });

    case 'REMOVE_POST':
      return state.filter((post) => post._id !== payload);

    case 'REMOVE_POSTS':
      // payload must be an array of post ID's to be removed
      return state.filter((post) => !payload.includes(post._id));

    case 'ADD_POSTS':
      idsList = payload.map((x) => x._id);

      return [...payload, ...state.filter((x) => !idsList.includes(x._id))];

    case 'ADD_POST':
      return [payload, ...state.filter((x) => payload._id !== x._id)];

    case 'ADD_REACTION_TO_POST':
      const { prevReaction, entityId, reaction } = payload;

      return state.map((post) => {
        if (post._id !== entityId) return post;

        // Guard: reactionCounts may be undefined on freshly fetched posts
        const reactionCounts = post.reactionCounts ?? {};
        let newReactions = {};

        const counts = post.reactionCounts ?? {};

        if (prevReaction && prevReaction === reaction) {
          newReactions = {
            [prevReaction]: (reactionCounts[prevReaction] ?? 0) - 1
          };
        }

        if (prevReaction && prevReaction !== reaction) {
          newReactions = {
            [prevReaction]: (reactionCounts[prevReaction] ?? 0) - 1,
            [reaction]: (reactionCounts[reaction] ?? 0) + 1
          };
        }

        if (!prevReaction) {
          newReactions = {
            [reaction]: (reactionCounts[reaction] ?? 0) + 1
          };
        }

        return {
          ...post,
          reactionCounts: {
            ...reactionCounts,
            ...newReactions
          }
        };
      });

    case 'INC_COMMENT_COUNT':
      return state.map((post) => {
        if (post._id !== payload.postId) return post;

        return {
          ...post,
          commentsCount: post.commentsCount + 1
        };
      });

    case 'UPDATE_LATEST_COMMENTS':
      return state.map((post) => {
        if (post._id !== payload.postId) return post;

        return {
          ...post,
          commentPreview: payload.latestComments || []
        };
      });

    case 'UPDATE_POST_VIEW_COUNT':
      return state.map((post) => {
        if (post._id !== payload.postId) return post;

        return {
          ...post,
          viewCount: payload.newCount
        };
      });

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
};

export default posts;
